/**
 * A device that opened the POS over plain http (HANDOVER open item 4: till
 * 192.168.1.9's live connection failed forever) has no secure context, so live
 * updates, offline saving and installing the app do not work there. Say so on the
 * screen, with the https link to use instead (operating law 3). Renders nothing on
 * https and on the developer's own localhost.
 */
export function insecureHttpsUrl(loc = window.location, secure = window.isSecureContext) {
  if (secure || loc.protocol !== "http:") return null;
  if (["localhost", "127.0.0.1", "[::1]"].includes(loc.hostname)) return null;
  return `https://${loc.hostname}${loc.pathname}${loc.search}`;
}

export default function InsecureBanner({ url = insecureHttpsUrl() }) {
  if (!url) return null;
  return (
    <div role="alert" data-testid="insecure-banner"
      className="fixed inset-x-0 bottom-0 z-[100] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t border-warning bg-warning-subtle px-4 py-2 text-center text-body font-medium text-warning">
      <span>This screen opened without https — live updates and offline saving do not work here.</span>
      <a className="underline font-semibold" href={url} data-testid="insecure-banner-link">Open the secure address</a>
    </div>
  );
}
